import { ENABLE_TRACKING, SRPRS_DEV, SRPRS_SANDBOX } from '../env'
import { settings } from '../settings'

import { conversions } from './conversions'
import { EventTypes } from './middleware/ActionTypes'
import { IMetrics } from './middleware/createMetrics'
import { ActiveCampaign } from './providers/activeCampaign'
import { GoogleAdWords } from './providers/adWords'
import { Bing } from './providers/bing'
import { Facebook } from './providers/facebook'
import { GoogleTags } from './providers/googleTags'
import { HotJar } from './providers/hotjar'
import { MemberGetMember } from './providers/member_get_member'
import { Snapchat } from './providers/snapchat'

const {
  googleOptimizeId,
  googleAnalyticsId,
  activeCampaign,
  bing,
  facebook,
  googleAdWords,
  googleTagManagerId,
  hotJar,
  memberGetMember,
  snapchat,
} = settings.tracking

const enabled = ENABLE_TRACKING || SRPRS_SANDBOX || !SRPRS_DEV
export const config: IMetrics = {
  enabled,
  vendors: [
    {
      name: 'HotJar',
      api: new HotJar(hotJar),
      experimentTracking: true,
    },
    {
      name: 'Google Analytics',
      api: new GoogleTags(
        googleAnalyticsId,
        googleOptimizeId,
        googleTagManagerId,
      ),
      conversions: conversions.google,
      experimentTracking: true,
    },
    {
      name: 'Facebook',
      api: new Facebook(facebook),
      conversions: conversions.facebook,
    },
    {
      name: 'GoogleAdWords',
      api: new GoogleAdWords(googleAdWords),
      conversions: conversions.adWords,
      events: [
        EventTypes.GIFTCARD_PURCHASE,
        EventTypes.PURCHASE,
        EventTypes.NEWSLETTER_SIGNUP,
      ],
    },
    {
      name: 'Active Campaign',
      api: new ActiveCampaign(activeCampaign),
    },
    {
      name: 'Bing',
      api: new Bing(bing),
      conversions: conversions.bing,
      events: [EventTypes.GIFTCARD_PURCHASE, EventTypes.PURCHASE],
    },
    {
      name: 'Snapchat',
      api: new Snapchat(snapchat),
      conversions: conversions.snapchat,
      events: [
        EventTypes.ADD_TO_CART,
        EventTypes.ENTRY_POINT,
        EventTypes.GIFTCARD_ADD_TO_CART,
        EventTypes.GIFTCARD_PURCHASE,
        EventTypes.NEWSLETTER_SIGNUP,
        EventTypes.PRODUCT_DETAILS_PAGE,
        EventTypes.PURCHASE,
      ],
    },
    {
      name: 'MemberGetMember',
      api: new MemberGetMember(memberGetMember),
      conversions: conversions.memberGetMember,
      events: [EventTypes.PURCHASE],
    },
  ],
}
